import {
    pharmacyDataGlobal,
    pharmacyDataFilteration,
    pharmacyDataDisHistory,
    pharmacyDataPrescription,
} from './shared/state';

export default {
    modules: {
        pharmacyDataGlobal,
        pharmacyDataFilteration,
        pharmacyDataDisHistory,
        pharmacyDataPrescription,
    }
};